<div class="container-fluid mt-4">
    <h4 class="mb-3 "><i class="fi fi-rr-newspaper"></i> კატეგორიები <span *ngIf="currentLang == 'en'">(EN)</span> </h4>
    <div class="row">
        <div class="col-md-3">
        <select [(ngModel)]="selectedItem" class="form-select mb-3" (change)="onChange()" >
            <option value="categories">კატეგორიები</option>
            <option value="municipalities">მუნიციპალიტეტები</option>
        </select>
        </div>
        <div class="col-md-3"> 
          <button class="btn btn-primary" (click)="add()">
              დამატება 
          </button>
        </div>
    </div>


    <div class="row g-4">
      <app-spinner [loading]="load" text="იტვირთება..."></app-spinner>
    </div>

    <div *ngIf="!load && (!data || data.length === 0)">
      ინფორმაცია ცარიელია
    </div>

    <div class="table-responsive">
      <table class="table table-bordered table-hover" *ngIf="data?.length">
        <thead>
          <tr>
            <th>#</th>
            <th>სათაური</th>
            <th>ქმედებები</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of data; let i = index">
            <td>{{ i + 1 }}</td>
            <td class="truncate-text">{{ item.title }}</td>
            <td>
              <div class="d-flex">

                <button class="btn btn-sm border rounded d-flex align-items-center mx-2" (click)="edit(item)">
                  <i class="fi fi-rr-pencil"></i>
                </button> 

              </div>
            </td>
          </tr>
        </tbody>
      </table>

    </div>

</div>

<ng-template #formModal>
  <app-page-form-modal
    [menuid]="selectedMenuType"
    [isCat]="true"
    [initialData]="selectedData"
    (save)="onSaved()"
    (closeModal)="onCloseModal()"
  ></app-page-form-modal>
</ng-template>